<script>
   /****************************************************************/
   /* ScoresPlot for SIMCA                                         */
   /* --------------------                                         */
   /* shows plot with PCA scores                                   */
   /****************************************************************/

    import ScoresPlot from "../../../shared/plots/ScoresPlot.svelte";

   // inputs
   export let params;                        // JSON with main plot parameters
   export let pcares;                        // JSON with result objects (PCA, PLS, etc)
   export let datasets;                      // current dataset
   export let selected = undefined;          // selected object or variable

   //
   let resID = 'cal';
   // reactive expressions to monitor changes in plot parameters
   $: if (params && params.resID !== resID) resID = params.resID;
</script>

{#if pcares && datasets && params }
<ScoresPlot bind:selected={selected} {params} res={pcares[resID]} dataset={datasets[resID]} resID={resID}/>
{/if}